import React from "react"
import Layout from "./components/layout"

// Aplica el Layout a cada página. Antes lo hacía la opción `layout` de
// gatsby-plugin-transition-link; en Gatsby 5 se usa wrapPageElement.
export const wrapPageElement = ({ element, props }) => {
	return <Layout {...props}>{element}</Layout>
}
